<template>
  <div>
    <div class="row">
      <div class="col-12 mt-5">
        <h5>
          <span>Vídeos</span>
        </h5>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12 text-center my-5">
        <button class="button default">Categoría 1</button>
        <button class="button default mx-2">Categoría 2</button>
        <button class="button default">Categoría 3</button>
      </div>
    </div> -->
    <div class="row">
      <div
        class="col-md-6 pointer"
        v-for="(item, i) in videos"
        :key="i"
        @click="openModal(item.title, item.url)"
      >
        <VideoCard :title="item.title" :videoSrc="item.url" />
      </div>
    </div>
    <ModalVideo
      v-bind="modalVideoOptions"
      v-if="showModal.modalVideo"
      @close="showModal.modalVideo = false"
    />
  </div>
</template>

<script>
import VideoCard from "@/components/videos/VideoCard";
import ModalVideo from "@/components/videos/ModalVideo";

export default {
  name: "Videos",
  components: {
    VideoCard,
    ModalVideo,
  },
  data() {
    return {
      showModal: {
        modalVideo: false,
      },
      modalVideoOptions: {
        title: null,
        videoUrl: null,
      },
      videos: [
        {
          title: "Video 1",
          url:
            "https://assets.beereaders.com/lbr/media/videos-demo/885566.mp4",
        },
        {
          title: "Video 2",
          url: "https://player.vimeo.com/video/414555649",
        },
        // {
        //   title: "Video 3",
        //   url:
        //     "https://player.vimeo.com/video/100902001?title=0&byline=0&portrait=0",
        // },
      ],
    };
  },
  methods: {
    openModal(title, videoUrl) {
      this.modalVideoOptions = { title, videoUrl };
      this.showModal.modalVideo = true;
    },
  },
};
</script>
